export default "__VITE_ASSET__CyaaUClp__"